export type BootstrapProgressState = {
  authReady: boolean;
  hasAuthenticatedUser: boolean;
  tenantReady: boolean;
  billingReady: boolean;
  routeReady: boolean;
};

/**
 * Reports completed bootstrap stages only. Each milestone is backed by a real
 * readiness signal; no timers or simulated increments are involved.
 */
export function calculateBootstrapProgress({
  authReady,
  hasAuthenticatedUser,
  tenantReady,
  billingReady,
  routeReady,
}: BootstrapProgressState): number {
  if (!authReady) return 0;
  if (!hasAuthenticatedUser || !tenantReady) return 25;
  if (!billingReady) return 50;
  if (!routeReady) return 75;
  return 100;
}
